import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from 'components/Loader';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import PinRequiredModal from 'components/PinRequiredModal';
import ScrollTop from 'components/ScrollTop';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { menuMaster, menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));

  // set media wise responsive drawer - jen v režimu "auto" (SidebarModeSwitch).
  // V režimu "user" se sidebar neřídí šířkou okna, zůstává přesně tak, jak
  // si ho uživatel ručně nastavil (přečteno z localStorage při načtení).
  // menuMasterLoading gate je nutný - SWR na první vykreslení ještě nemá
  // menuMaster.sidebarMode hotové (undefined), takže by se bez gate bral
  // jako "auto" i pro uživatele, co si zvolil "user", a hned by to
  // přepsalo jeho ručně nastavené/zapamatované otevření zpět podle šířky okna.
  useEffect(() => {
    if (menuMasterLoading) return;
    if (menuMaster?.sidebarMode === 'user') return;
    handlerDrawerOpen(!downXL);
  }, [downXL, menuMasterLoading, menuMaster?.sidebarMode]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <ScrollTop />
      <PinRequiredModal />
      <Header />
      <Drawer />

      <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
        <Toolbar sx={{ mt: 'inherit' }} />
        <Box
          sx={{
            ...{ px: { xs: 0, sm: 2 } },
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Breadcrumbs />
          <Outlet />
          <Footer />
        </Box>
      </Box>
    </Box>
  );
}
